import React from 'react';

const isUrl = val => {
  if (typeof val !== 'string') return false;
  const trimmed = val.trim();
  return /^https?:\/\/\S+/i.test(trimmed);
};

const SubmissionDetails = ({
  submission,
  getMainDescription,
  sanitizeAIText,
  colSpan = 6,
}) => (
  <tr className="bg-gray-50">
    <td colSpan={colSpan} className="py-6 px-6">
      <div className="max-w-5xl mx-auto space-y-4">
        {/* Description */}
        <div className="bg-white rounded-lg p-4 border border-gray-100">
          <h4 className="font-bai font-semibold text-gray-900 text-base mb-3">
            Description
          </h4>
          <p className="font-bai text-sm text-gray-700 leading-relaxed">
            {getMainDescription(submission)}
          </p>
        </div>

        {/* AI Evaluation Results */}
        {submission.judgment_data ? (
          <div className="bg-white rounded-lg p-4 border border-gray-100">
            <h4 className="font-bai font-semibold text-gray-900 text-base mb-4">
              Evaluation Results
            </h4>

            {/* Score Breakdown */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-4">
              {Object.entries(submission.aspect_scores).map(
                ([aspectName, aspectData]) => (
                  <div key={aspectName} className="bg-gray-100 rounded-lg p-3">
                    <div className="flex justify-between items-center mb-2">
                      <span className="font-bai text-sm font-semibold text-gray-700">
                        {aspectName}
                      </span>
                      <span className="font-bai text-sm font-bold text-gray-900">
                        {aspectData.score}/10
                      </span>
                    </div>
                    <p className="font-bai text-sm text-gray-600 leading-relaxed">
                      {sanitizeAIText(aspectData.comment)}
                    </p>
                  </div>
                )
              )}
            </div>

            {/* Overall Summary */}
            {submission.overall_summary && (
              <div className="bg-blue-50 rounded-lg p-3 border-l-4 border-blue-500">
                <h5 className="font-bai text-sm font-semibold text-blue-700 mb-2">
                  Overall Assessment
                </h5>
                <p className="font-bai text-sm text-blue-700 leading-relaxed">
                  {sanitizeAIText(submission.overall_summary)}
                </p>
              </div>
            )}
          </div>
        ) : (
          <div className="bg-white rounded-lg p-4 border border-gray-100 text-center">
            <p className="font-bai text-sm text-gray-500">
              This submission is awaiting evaluation.
            </p>
          </div>
        )}

        {/* Additional Details */}
        {Object.entries(submission.detailed_fields).length > 0 && (
          <div className="bg-white rounded-lg p-4 border border-gray-100">
            <h4 className="font-bai font-semibold text-gray-900 text-base mb-3">
              Additional Information
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              {Object.entries(submission.detailed_fields)
                .slice(0, 6)
                .map(([key, value]) => (
                  <div key={key} className="bg-gray-100 rounded-lg p-3 min-w-0">
                    <h5 className="font-bai text-xs font-semibold text-gray-600 mb-1 uppercase tracking-wide">
                      {key}
                    </h5>
                    <p className="font-bai text-sm text-gray-900 leading-relaxed break-words">
                      {isUrl(value) ? (
                        <a
                          href={value.trim()}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-600 hover:text-blue-800 hover:underline break-all"
                        >
                          {value.trim().length > 100
                            ? `${value.trim().substring(0, 100)}...`
                            : value.trim()}
                        </a>
                      ) : typeof value === 'string' && value.length > 100 ? (
                        `${value.substring(0, 100)}...`
                      ) : (
                        value
                      )}
                    </p>
                  </div>
                ))}
            </div>
            {Object.entries(submission.detailed_fields).length > 6 && (
              <p className="font-bai text-xs text-gray-500 mt-3 text-center">
                +{Object.entries(submission.detailed_fields).length - 6} more
                fields
              </p>
            )}
          </div>
        )}
      </div>
    </td>
  </tr>
);

export default SubmissionDetails;
